enum UserStepsEnum {
  ACTIVATION_CODE_STEP = 'ACTIVATION_CODE_STEP',
  PROFILE_STEP = 'PROFILE_STEP',
  BOOKING_PREFERENCE_STEP = 'BOOKING_PREFERENCE_STEP',
  TERMS_AND_CONDITIONS_STEP = 'TERMS_AND_CONDITIONS_STEP',
  COMPLETED_STEP = 'COMPLETED_STEP',
}

export default UserStepsEnum;
